import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};
export const StairsIcon = ({ width = 40, height = 40, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M22.111 14.1724V16.931C22.111 17.0276 22.0376 17.1034 21.9442 17.1034H18.7223C18.6289 17.1034 18.5555 17.1793 18.5555 17.2759V20.0345C18.5555 20.131 18.4821 20.2069 18.3887 20.2069H15.1668C15.0734 20.2069 15 20.2828 15 20.3793V23.8276C15 23.9241 15.0734 24 15.1668 24H18.5555H22.111H25.8332C25.9266 24 26 23.9241 26 23.8276V20.2069V17.1034V14.1724C26 14.0759 25.9266 14 25.8332 14H22.2777C22.1844 14 22.111 14.0759 22.111 14.1724Z"
                fill={fill}
                stroke={fill}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
        </svg>
    );
};
